import { createSelector } from 'reselect'

export const selectHome = state => state.home

export const selectHomeData = createSelector(selectHome, home => home.data)

export const selectHomeIsLoading = createSelector(selectHome, home => home.isLoading)

export const selectHomeError = createSelector(selectHome, home => home.error)

export const selectIsEditingSpeedFormation = createSelector(selectHome, home => home.isEditingSpeedFormation)

export const selectSpeedFormationDate = createSelector(selectHome, home => home.speedFormationDate)

export const selectSpeedFormationSave = createSelector(selectHome, home => home.speedFormationSave)
